import { Pipe, PipeTransform } from "@angular/core";
import * as _ from 'underscore';

@Pipe({name: "sort"})
export class ArraySortPipe implements PipeTransform {
  transform(array: Array<any>, field: string, dir?:string): any[] {

    var sortDir = dir === "ASC" ? 1 : dir === "DESC" ? 0 : 1

    if(_.isArray(array) && array.length>0) {

      return array.sort( (a: any, b: any) => {
        const A = a[field] 
        const B = b[field]
        if(_.isNumber(A) && _.isNumber(B)) {
          if (A < B) {
            return sortDir ? -1 : 1;
          } 
          else if (A > B) {
            return sortDir ? 1 : -1;
          } 
          else {
            return 0;
          }
        }
        else if(_.isString(A) && _.isString(B)) {
          return A.toLowerCase().localeCompare(B.toLowerCase());
        }
      });
    }
    else return array;
  }
}



@Pipe({ name: 'reverse' })
export class ReversePipe implements PipeTransform {
  transform(array: any[]) {
    return array.slice().reverse();
  }
}
